// extracted by mini-css-extract-plugin
module.exports = {"base":"ServiceIframe_base__3whQi","sub-tab":"ServiceIframe_sub-tab__2GlPH","full-pane":"ServiceIframe_full-pane__3lcHb","main-bar":"ServiceIframe_main-bar__3OfWW"};